export const LOGIN = 'LOGIN'
export const lOGOUT = 'LOGOUT'
